const analysis = function (type) {
  if (type == 0) {
    fbq('track', 'AddToCart')
    window.gtag_report_conversion_google()
  } else {
    fbq('track', 'AddToWishlist');
    window.gtag_report_conversion_appstore()

  }
}
export { analysis }
